const StoryLoader = () => {
  return ( 
    <p>Loading parent story...</p>
  );
}
 
export default StoryLoader;